export default {
  setBreadcrumbs: ({ commit }: any, list: any) => {
    console.log('list', list)
    commit('SET_BREADCRUMBS', list)
  }
}
